import { render, staticRenderFns } from "./OnboardingSigninIos.vue?vue&type=template&id=9aaf6f12&"
import script from "./OnboardingSigninIos.vue?vue&type=script&lang=js&"
export * from "./OnboardingSigninIos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports